import React from 'react';
import { propEq } from 'ramda';

import { Artwork, IMAGE_URL_TYPE } from '@definitions/artworks.types';
import { HiddenContainer } from '@components/PLP/hiddenContainer';
import { ArtworkCard, ArtworkDetail } from '@components/artworkCard';
import { CUSTOM_FIELDS } from '@modules/artworks/artworks.constants';
import { renderWhenOtherwise } from '@utils/rendering';
import { PRODUCT_TYPE } from '@utils/constants';
import { GiftCertificateCard } from '@components/giftCertificateCard';

import { GridItem, GridList, GridItemWrapper } from './largeGrid.styles';

export interface LargeGridProps {
  artworks: Artwork[];
}

export const LargeGrid = ({ artworks }: LargeGridProps) => {
  const renderArtwork = renderWhenOtherwise(
    propEq('type', PRODUCT_TYPE.PRODUCT),
    (artwork) => (
      <GridItem>
        <ArtworkCard artwork={artwork} imageWidth="100%" imageUrlType={IMAGE_URL_TYPE.URL_STANDARD} withSlickSlider>
          <ArtworkDetail>
            {artwork.title}, {artwork.year}
          </ArtworkDetail>
          <ArtworkDetail>{artwork.medium}</ArtworkDetail>
        </ArtworkCard>
      </GridItem>
    ),
    (giftCertificate) => (
      <GridItem>
        <GiftCertificateCard imageWidth="100%" giftCertificate={giftCertificate} />
      </GridItem>
    )
  );

  return (
    <GridList>
      {artworks.map((artwork, index) => (
        <GridItemWrapper key={index} layoutL={artwork[CUSTOM_FIELDS.LAYOUT_L]}>
          <HiddenContainer index={index} />
          {renderArtwork(artwork)}
        </GridItemWrapper>
      ))}
    </GridList>
  );
};
